<lib-basys-graphics-core-data-access #dataAccess>
  <abc-toolbar #toolbar>
    <dxi-item widget="dxButton" location="before" [options]="toolbarRefreshButtonOptions"></dxi-item>
    <dxi-item widget="dxButton" location="before" [options]="toolbarResetZoomButtonOptions"></dxi-item>
    <dxi-item widget="dxButton" location="before" [options]="toolbarPrintButtonOptions"></dxi-item>
    <dxi-item widget="dxButton" location="before" [options]="toolbarSettingsButtonOptions"></dxi-item>
  </abc-toolbar>
  <lib-basys-graphics-core-scalable-image
    #scalableImage
    (onFeatureClicked)="handleFeatureClicked($event)"
  ></lib-basys-graphics-core-scalable-image>
</lib-basys-graphics-core-data-access>
@if (loadPanelPosition && isLoadPanelVisible) {
  <div class="load-panel-container">
    <svg class="spinner" viewBox="-10 -10 120 120">
      <circle class="path" cx="50" cy="50" r="50" fill="none" stroke-width="4" stroke-miterlimit="10" />
    </svg>
  </div>
}

<abc-popup
  id="option-popup"
  [wrapperAttr]="{ class: 'option-popup-wrapper' }"
  [width]="400"
  [height]="'auto'"
  [dragEnabled]="false"
  [showCloseButton]="true"
  [title]="resourceSet.get('Settings')"
  [position]="{ at: 'center', my: 'center', of: dataAccessElement().nativeElement }"
  [(visible)]="isSettingsPopupVisible"
  (onHidden)="handleSettingsPopupHidden()"
>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="settingsPopupAcceptButtonOptions"
  ></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="settingsPopupCancelButtonOptions"
  ></dxi-popup-toolbar-item>

  <div class="optionen-popup">
    <abc-drop-down-box
      labelMode="floating"
      [dropDownOptions]="{ wrapperAttr: { class: 'longitudinal-section-popup' } }"
      [label]="resourceSet.get('GraphicsDocument')"
      [dataSource]="longitudinalSectionSettings.longitudinalSectionSettings.graphicsDocuments"
      [displayExpr]="'displayText'"
      [valueExpr]="'id'"
      [gridColumns]="[{ dataField: 'displayText' }]"
      [hideColumnHeaders]="true"
      [(value)]="longitudinalSectionSettings.graphicsDocumentId"
    ></abc-drop-down-box>

    <abc-drop-down-box
      labelMode="floating"
      [dropDownOptions]="{ wrapperAttr: { class: 'longitudinal-section-popup' } }"
      [label]="resourceSet.get('VerticalScale')"
      [dataSource]="longitudinalSectionSettings.longitudinalSectionSettings.verticalScales"
      [displayExpr]="'displayText'"
      [valueExpr]="'id'"
      [gridColumns]="[{ dataField: 'displayText' }]"
      [hideColumnHeaders]="true"
      [(value)]="longitudinalSectionSettings.verticalScale"
    ></abc-drop-down-box>

    <abc-drop-down-box
      labelMode="floating"
      [dropDownOptions]="{ wrapperAttr: { class: 'longitudinal-section-popup' } }"
      [label]="resourceSet.get('HorizontalScale')"
      [dataSource]="longitudinalSectionSettings.longitudinalSectionSettings.horizontalScales"
      [displayExpr]="'displayText'"
      [valueExpr]="'id'"
      [gridColumns]="[{ dataField: 'displayText' }]"
      [hideColumnHeaders]="true"
      [(value)]="longitudinalSectionSettings.horizontalScale"
    ></abc-drop-down-box>

    <abc-drop-down-box
      labelMode="floating"
      [dropDownOptions]="{ wrapperAttr: { class: 'longitudinal-section-popup' } }"
      [label]="resourceSet.get('ReportDocument')"
      [dataSource]="longitudinalSectionSettings.longitudinalSectionSettings.reportDocuments"
      [displayExpr]="'displayText'"
      [valueExpr]="'id'"
      [gridColumns]="[{ dataField: 'displayText' }]"
      [hideColumnHeaders]="true"
      [(value)]="longitudinalSectionSettings.reportDocumentId"
    ></abc-drop-down-box>
  </div>
</abc-popup>
